import type { IUserRepository } from '../domain/IUserRepository'
import type { User } from '../domain/user'

export class UpdateUserUseCase {
    constructor(private repository: IUserRepository) {}

    async execute(
        userId: number,
        data: Partial<Omit<User, 'id'>>
    ): Promise<User> {
        return await this.repository.update(userId, data)
    }
}
